import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Router, Switch, Route, Link } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import * as serviceWorker from './serviceWorker'
import PageWithStripeElements from './PageWithStripeElements'

ReactDOM.render(
  <Router history={createBrowserHistory()}>
    <div className='App'>
      <header className='App-header'>
        <Switch>
          <Route exact component={App} path='/' />
          <Route component={PageWithStripeElements} path='/' />
        </Switch>
        <div style={{ marginTop: 64 }}>
          <Link className='appLink' to='/'>
            Home
          </Link>{' '}
          <Link style={{ color: 'yellow', marginLeft: 32 }} className='appLink' to='/payment'>
            {' '}
            Payment Page
          </Link>
        </div>
      </header>
    </div>
  </Router>,

  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
